import React, { Component } from 'react';
import createClass from 'create-react-class';
import cIf from 'classnames';

var _ = require('lodash');

// Params: items: items, getId: f(item -> itemid), getInnerCtl: f(item -> itemControl). Opt: onItemSelected: f(itemId)
export const SelectableList = createClass({
    displayName: "SelectableList",

    getInitialState: function() {
        var selectedId = null;
        if(this.props.items.length > 0)
            selectedId = this.props.getId(this.props.items[0]);

        return { selectedId: selectedId };
    },
    getDefaultProps: function () {
        return { getClickable:  true };
    },
    onItemClick: function(itemId){
        this.setState({  selectedId: itemId });
        if(this.props.onSelect !== undefined) this.props.onSelect(itemId);
    },
    render: function() {
        var list = _.map(this.props.items, (item) => {
            var selected = this.props.getId(item) == this.state.selectedId;
            return <SelectableListItem item={item} selected={selected} getId={this.props.getId} getInnerCtl={this.props.getInnerCtl} getClickable={this.props.getClickable} onClick={this.onItemClick} key={this.props.getId(item)} haveRadioButton={this.props.haveRadioButton} />;
        });
        
        return (
            <div className={"selectableList " + this.props.className}>
                {list}
            </div>
        );
    }


});

export const SelectableListItem = createClass({
    displayName: "SelectableListItem",

    getInitialState: function(e){
        return { mouseIn: false };
    },
    onMouseEnter: function(e) { if(this.props.getClickable(this.props.item)) this.setState({ mouseIn: true }); },
    onMouseOut: function(e){ if(this.props.getClickable(this.props.item)) this.setState({ mouseIn: false }); },
    onClick: function(e) { if(this.props.getClickable(this.props.item)) this.props.onClick(this.props.getId(this.props.item)); },
    render: function() {

        return (
            <div onMouseEnter={this.onMouseEnter}
                 onMouseLeave={this.onMouseOut}
                 className={cIf({
                         listItem: true,
                         selected: this.props.selected,
                         mouseHover: this.props.getClickable(this.props.item) && this.state.mouseIn && !this.props.selected
                     })}
                 onClick={this.onClick}>
                <div>
                    {this.props.getInnerCtl(this.props.item)}
                </div>
            </div>
        );
    }

});
